// deviceManager.js
let deviceId = null;

const setDeviceId = (newDeviceId: string) => {
  deviceId = newDeviceId;
};

const getDeviceId = () => deviceId;

const clearDeviceId = () => {
  deviceId = null;
};

export default {
  setDeviceId,
  getDeviceId,
  clearDeviceId,
};
